// Styles.
import '@app/preload.styles'
import MediaQueries from '@app/scripts/MediaQueries.js';

// JS
window.mediaQueries = MediaQueries();

window.imgOnLoad = () => {}
import '@resources/grrr/grrr'; // grrr ui size variable.
window.addEventListener('DOMContentLoaded', (e) => document.querySelector('html').classList.remove('no-js') )

